export default {
      id: "down-arrow-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#down-arrow",
      toString: function () {
        return this.url;
      }
    }